'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.validateAbhyasiId = exports.validatePNR = exports.validateEmail = exports.email_regex = exports.pnr_regex = exports.abhyasiid_regex = void 0;

var _typeof2 = require('babel-runtime/helpers/typeof'),
    _typeof3 = _interopRequireDefault(_typeof2),
    _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray'),
    _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.validateRE = validateRE, exports.validatePhoneNumber = validatePhoneNumber, exports.computeRule = computeRule, exports.validateConstraints = validateConstraints, exports.validateField = validateField;

var _googleLibphonenumber = require('google-libphonenumber'),
    _get = require('lodash/get'),
    _get2 = _interopRequireDefault(_get),
    _utils = require('./utils'),
    _formatting = require('./formatting');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var abhyasiid_regex = exports.abhyasiid_regex = '^([a-zA-Z]{6}[0-9]{3}|[HABhab]{1}[0-9]{8})$',
    pnr_regex = exports.pnr_regex = '^[0-9A-Z]{2}-[A-Z]{4}-[A-Z]{4}$',
    email_regex = exports.email_regex = '(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))';

function validateRE(a, b) {
  var c = RegExp(a);
  return c.test(b + '');
}

function validatePhoneNumber(a) {
  if (validateRE(/\d{10}/, a)) // valid 10 digit format
    return !0;
  var b = !1;

  try {
    var c = _googleLibphonenumber.PhoneNumberUtil.getInstance();

    b = c.isValidNumber(c.parse(a));
  } catch (a) {
    b = !1;
  }

  return b;
}

var validateEmail = exports.validateEmail = function (a) {
  return validateRE(email_regex, a);
},
    validatePNR = exports.validatePNR = function (a) {
  return validateRE(pnr_regex, a);
},
    validateAbhyasiId = exports.validateAbhyasiId = function (a) {
  return validateRE(abhyasiid_regex, a);
};

function computeRule(a, b, c) {
  // console.log("ComputeRule", rule, state, at_element);
  // format of a rule
  // [ [":variable", "+", "string"], "-", 27 ]
  // state is dict containing :variable as a key
  var d = /^\d\d\d\d-\d\d-\d\d$/,
      e = [];
  'string' == typeof c ? e = [c] : Array.isArray(c) && (e = [].concat((0, _toConsumableArray3.default)(c))), e.splice(e.length - 1, 1);

  var f = function f(a) {
    if (Array.isArray(a)) return g(a);
    if (a instanceof Date) return (0, _utils.daysDiff)((0, _formatting.formatSys2OdooDate)(a), '1980-01-01');

    if ('string' == typeof a) {
      if (a.startsWith(':')) {
        var c;
        return a.startsWith(':~') ? (c = a.substring(2), c = [].concat((0, _toConsumableArray3.default)(e), [c]), void 0) : c = a.substring(1), ':TODAY' === c ? (0, _utils.daysDiff)((0, _formatting.formatSys2OdooDate)(new Date()), '1980-01-01') : ':TODAY_SHORT' === c ? (0, _formatting.formatSys2OdooDate)(new Date()) : ':TODAY_YEAR' === c ? new Date().getFullYear() : d.test((0, _get2.default)(b, c, '')) ? (0, _utils.daysDiff)((0, _get2.default)(b, c), '1980-01-01') : (0, _get2.default)(b, c);
      }

      return d.test(a) ? (0, _utils.daysDiff)(a, '1980-01-01') : a;
    }

    return a;
  },
      g = function g(c) {
    var d = f(c[0]),
        a = c[1],
        e = f(c[2]); //console.log("a", a, "op", op, "b", b);

    return 'IF' === a ? e ? d : null : 'IS' === a ? 'SET' === e || 'NOTNULL' === e ? !!d : 'EMPTY' === e || 'NULL' === e ? !d : 'ARRAY' === e ? Array.isArray(d) : d === e : 'IN' === a ? 'string' == typeof e ? -1 < e.search(d) : 'object' === ('undefined' == typeof e ? 'undefined' : (0, _typeof3.default)(e)) ? d in e : null : 'LIKE' === a ? validateRE(e, d) : '+' === a ? d + e : '-' === a ? d - e : '/' === a ? Math.round(d / e) : '*' === a ? d * e : '%' === a ? d % e : '>' === a ? d > e : '>=' === a ? d > e : '<' === a ? d < e : '<=' === a ? d <= e : '==' === a ? d == e : '!=' === a ? d != e : '&&' === a ? d && e : '||' === a ? d || e : 'XOR' === a ? d ? !e : e : 'XAND' === a ? d ? e : !e : '=>' === a ? !d || e : 'IF' === a ? !!e && d : 'ELSE' === a ? d ? d : e : 'SWITCH_DICT' === a ? 'string' == typeof d && 'object' === ('undefined' == typeof e ? 'undefined' : (0, _typeof3.default)(e)) ? d in e ? e[d] : '##DEFAULT##' in e ? e['##DEFAULT##'] : '##IGNORE##' : '##IGNORE##' : void 0;
  };

  return g(a);
}
/*
Format of Constraints
triplet style
cond is [['a', '==', 'a'], '&&', [':b', '!=', 21]]
[ {conds: ["is_prefect", "=", true], msg: "Participants should be a Prefect"}
*/


function validateConstraints(a, b) {
  var c = [];

  try {
    a.map(function (a) {
      var d = a.conds,
          e = a.msg;
      d && b || c.push('Invalid Constraints');
      var f = computeRule(d, b, []);
      void 0, !0 === f || c.push(e);
    });
  } catch (a) {
    c.push('Invalid Constraints: ' + a);
  }

  return 0 < c.length ? c.toString() : '';
}

function validateField(a, b, c) {
  if (!a) return !1;

  try {
    var d = computeRule(a, {
      value: b
    }, c);
    return !(d && '##IGNORE##' !== d);
  } catch (a) {
    return alert(a), !0;
  }
}